<div
  class="toast mx-auto animate__animated animate__fadeInRight"
  [class.toast-success]="mode === 'success'"
  [class.toast-warning]="mode === 'warning'"
  [class.toast-error]="mode === 'error'"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  <div
    class="toast-header"
    [class.toast-success]="mode === 'success'"
    [class.toast-warning]="mode === 'warning'"
    [class.toast-error]="mode === 'error'"
  >
    @if (mode === 'success') {
      <i class="fas fa-check fa-lg me-2"></i>
      <h4 class="me-auto fw-bold">Success!</h4>
    } @else {
      <i class="fas fa-exclamation-circle fa-lg me-2"></i>
      <h4 class="me-auto fw-bold">{{ mode | titlecase }}</h4>
    }
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="notificationRef.close()"
    ></button>
  </div>
  <h5 class="toast-body fw-bold">{{ message }}</h5>
</div>